// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3kn6S","topBottomGutter":"Layout_topBottomGutter__hWdEP"};